import React from 'react'
import { Heading, Text } from '@primer/react-brand'
import Container from './Container'
import SectionHeader from './landing/SectionHeader'
import Eyebrow from './landing/Eyebrow'
import { ROADMAP, PENDING } from '../landingContent'

// Where the platform is going, from the prospectus. A serious buyer wants to
// know a tool has a future; a serious tool can say so plainly, with dates, and
// with the caveat the prospectus itself carries.
const RoadmapSection = () => {
  if (!PENDING.roadmap) return null
  return (
    <section id="roadmap" style={{ padding: '96px 0', background: 'var(--brand-color-canvas-default)' }}>
      <Container>
        <div className="roadmap-grid" style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 5fr) minmax(0, 7fr)', gap: '64px' }}>
          <div>
            <SectionHeader
              eyebrow="Where it is going"
              heading="A roadmap drawn from the people who use it."
              lede="These are not speculative features. They are the capabilities current members have identified as the highest-impact investments for their work. Timing shifts with funding and demand."
            />
          </div>

          <ol style={{ listStyle: 'none', margin: 0, padding: 0 }}>
            {ROADMAP.map(({ when, heading, body }, i) => {
              const last = i === ROADMAP.length - 1
              return (
                <li
                  key={when}
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '112px 1fr',
                    gap: '20px',
                    paddingBottom: last ? 0 : '32px',
                    position: 'relative',
                  }}
                >
                  <div>
                    <Eyebrow as="span" style={{ display: 'block', paddingTop: '3px', whiteSpace: 'nowrap' }}>{when}</Eyebrow>
                  </div>
                  <div style={{ position: 'relative', paddingLeft: '24px' }}>
                    {/* rail + node */}
                    <span
                      aria-hidden="true"
                      style={{
                        position: 'absolute',
                        left: 0,
                        top: '6px',
                        width: '9px',
                        height: '9px',
                        borderRadius: '50%',
                        background: i === 0 ? 'var(--base-color-scale-blue-5)' : 'var(--brand-color-canvas-default)',
                        border: '2px solid var(--base-color-scale-blue-5)',
                        boxSizing: 'border-box',
                      }}
                    />
                    {!last && (
                      <span
                        aria-hidden="true"
                        style={{
                          position: 'absolute',
                          left: '4px',
                          top: '18px',
                          bottom: '-32px',
                          width: '1px',
                          background: 'var(--brand-color-border-default)',
                        }}
                      />
                    )}
                    <Heading as="h3" size="6" weight="semibold">{heading}</Heading>
                    <Text as="p" size="200" variant="muted" style={{ marginTop: '8px', marginBottom: 0 }}>{body}</Text>
                  </div>
                </li>
              )
            })}
          </ol>
        </div>
      </Container>
    </section>
  )
}

export default RoadmapSection
